// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1561":"3be8da42","3966":"c2727557","5817":"f0e9d365","7350":"7e5d29d2"}[chunkId] + ".chunk.css";
};